import {LocalStorageEnum} from "../enum/localStorage";

export const resetRegister = () => {
    localStorage.removeItem(LocalStorageEnum.phone)
    localStorage.removeItem(LocalStorageEnum.phoneSubmit)
    localStorage.removeItem(LocalStorageEnum.mail)
    localStorage.removeItem(LocalStorageEnum.mailSubmit)
    localStorage.removeItem(LocalStorageEnum.expiresIn)
    localStorage.removeItem(LocalStorageEnum.smsTime)
    localStorage.removeItem(LocalStorageEnum.codeTime)
    localStorage.removeItem(LocalStorageEnum.registered)
    localStorage.removeItem(LocalStorageEnum.access_token)
    localStorage.removeItem('selectedUser')
}
